<div [ngClass]="type" class="subscription-banner" layout-space-between>
  <div layout layout-align-items-center>
    <rt-icon [name]="iconName" size="small" margin-right-small-x />
    <span [innerHTML]="bannerMessage" class="banner-message" margin-right-small-xx> </span>
    @if (!!linkText) {
      <a
        class="link"
        [class.bold]="linkBold ? true : null"
        [routerLink]="linkUrl"
        (click)="linkClick.emit()"
      >
        {{ linkText }}
      </a>
    }
    @if (isDismissible) {
      <rt-icon-button
        (click)="onCloseClick($event)"
        margin-left-auto
        class="close-btn"
        size="small"
        variant="plain"
        iconName="close"
        shape="square"
      />
    }
  </div>
  <div>
    <ng-content />
  </div>
</div>
